import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { groupSchemaObject } from '../../Data'
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import authService from '../../Common/services';

const screenCode = 'GROUP';

export function GroupAddEdit(props){

    const useStyles = makeStyles((theme) => ({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    }));
    const classes = useStyles();
    const {data, edit} = props.location
    const [title, setTitle] = useState("Add Group")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [group, setGroup] = useState({
        groupCode: '',
        groupName: '',
        isActive: true
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    
    const schema = Joi.object(groupSchemaObject).options({allowUnknown: true})

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITGROUP');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }
        
        if (data && edit) {
            setTitle("Edit Group");
            setGroup(data);
            setButtonName("Update");
        } else {
            setTitle("Add Group");
        }
    }

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [group]);

    function handleChange(e){
        const target = e.target

        if(target.name === "groupCode") {
            if(target.value.length === 3) return false
        }

        const value = target.name === 'isActive' ? target.checked: target.value
        
        const error = {...errors}
        const errorMessage = validateProperty(target, groupSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        
        setGroup({
            ...group,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e){
        e.preventDefault()

        const errorMessages = validate(schema, group)
        errorMessages !== null ?  setErrors(errorMessages) : setErrors({})
        if(errorMessages) return

        if(!edit) {
            const response = await services.saveGroup(group)
            setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message})
            afterSuccessfulyChanged(response.statusCode)
        }
        if(edit) {
            const response = await services.editData(group)
            setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message})
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if(response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({pathname: '/groups'})
            }, 1500);
        }
    }

    function clearState() {
        setGroup({...group,
            groupCode: '',
            groupName: '',
            isActive: true
        })
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function modalDismissHandler() {
        setMessageModel({...messageModel, hidden: true})
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/groups"
                        />

                        <form onSubmit={(e) => handleSave(e)}>
                        <div className="card-body">
                          
                    
                                <div className="form-group row">
                                    <div className="col-md-4">
                                       
                                        <TextField fullWidth label="Group Code *" 
                                            name="groupCode"
                                            id="groupCode"
                                            value={group.groupCode}
                                            type="number"
                                            maxLength="2"
                                            onChange={(e) => handleChange(e)}/>
                                        {errors["groupCode"] && <span id="errbranchCode" className="text text-danger">{errors["groupCode"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                       
                                        <TextField fullWidth label="Group Name *"
                                            name="groupName"
                                            id="groupName"
                                            value={group.groupName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["groupName"] && <span id="errbranchCode" className="text text-danger">{errors["groupName"]}</span>}
                                    </div>
                                </div>

                               <br/>
                                <label htmlFor="switch1" >Active</label>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                    <input
                                        className="mr-2"
                                        id="isActive"
                                        switch="none"
                                        type="checkbox" 
                                        name="isActive"
                                        onChange={(e) => handleChange(e)}
                                        checked={group.isActive}
                                    />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                               
                                
                          

                        </div>

                        <div className="card-footer">
                                <input
                                    disabled={validate(schema, group)} 
                                    type="submit" 
                                    className="btn btn-primary" 
                                    value={buttonName} 
                                />
                                <input

                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick} 
                                />
                            </div>
                              </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}